import { contactNumbers } from '@adc/constants'
import { utils } from '@adc/ui-adc'
const { formatPhoneNumber } = utils.formatters

export const ADDRESS_ERROR_MESSAGE =
  'Required field. Try typing the address and selecting a result from the list.'

export const ADDRESS_ALREADY_USED_MESSAGE = `This address already has a listing attached to it. If you believe this to be an error, please contact SmartSale Concierge team for further assistance at SmartSale@auction.com or ${formatPhoneNumber(
  contactNumbers.SMART_SALE_CONCIERGE
)}.`
